export default "__VITE_ASSET__DlRe7SrT__"